import { css, html, LitEntity } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import './parts/work-order-grid';

class WorkorderGridView extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
    `];
  }

  render() {
    return html`
      <h1>Work Orders</h1>
      <work-order-grid .href="${this.href}"></work-order-grid>
    `;
  }
}

window.customElements.define('work-order-grid-view', WorkorderGridView);
